import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { EmployerService } from '../../employer.service';
import { PostJobData } from './postJobData';
import { AuthService } from 'src/app/auth/auth.service';
import { async } from '@angular/core/testing';
import { MatSnackBar } from '@angular/material';

interface JobTypes {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-post-job',
  templateUrl: './post-job.component.html',
  styleUrls: ['./post-job.component.css']
})
export class PostJobComponent implements OnInit {

  myControl = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  myControl1 = new FormControl();
  options1: string[] = ['enter a question'];
  filteredSkills: Observable<string[]>;
  filteredOptions: Observable<string[]>;
  filteredOptions1: Observable<string[]>;

  question = '';
  questionList = [];
  allSkills = [];
  sucessMsg;
  types: JobTypes[] = [
    { value: 'Contract', viewValue: 'Contract' },   
    { value: 'FullTime', viewValue: 'FullTime' }, 
    { value: 'Intership', viewValue: 'Intership' },
  ];

  skillInput = '';
  additionalSkillInput = '';
  skillsControl = new FormControl();
  primarySkills: string[] = ['One', 'Two', 'Three'];
  additionalSkills: string[] = ['One', 'Two', 'Three'];

  showAddSkill1 = false;

  showAddSkill2 = false;
  newSkillAdded = false;
  statusFailure = false;
  statusSuccess = false;
  statusLoading = false;
  statusFailure2 = false;
  statusSuccess2 = false;
  statusLoading2 = false;
  filteredLocations: Observable<string[]>;
  locationOptions: string[] = [];
  locationControl = new FormControl();
  card = {
    form1: true,
    form2: true,
  }

  postJobData: PostJobData = {
    emp_id: '',
    job_title: '',
    company: '',
    job_location: '',
    employement_type: '',
    job_type: {
      name: '',
      total_experience: ''
    },
    job_roles: [],
    work_authorization: {
      any: false,
      opt: false,
      cpt: false,
      h1b: false,
      green_card: false,
      us_citizen: false
    },
    job_description: '',
    skills: {
      primarySkills: [],
      additionalSkills: []
    },
    status: '',
    open_positions: '',
    screening_questions: []
  }

  jobId = '';
  showAddQns = true;
  postEnable = true;
  editEnable = false;
  EditDraftEnable = false;
  // submitData = {
  //   _id:'',
  //   data:{}
  // };


  jobTypes = [];
  jobType = {
    name: '',
    total_experience: ''
  }
  jobRoleExperienceList = [];
  selectedJobRoles = [];
  experiences = ['0-1 years', '1-2 years', '2-4 years', '4-6 years', '6-10 years', '10-15 years', '15+ years']
  positions = ['1', '2','3', '4','5', '6','7', '8','9', '10','11', '12','13', '14','15', '16','17', '18','19', '20' ]
  flagDesc: boolean = false;
  flagRole: boolean = false;
  isEdit: boolean = false;
  card2: boolean = false;
  card3: boolean = false;

  // private formTwoSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  // public formTwo: Observable<boolean> = this.formTwoSubject.asObservable();
  // private formThreeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  // public formThree: Observable<boolean> = this.formThreeSubject.asObservable();

  private formTwoSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formTwo: Observable<boolean> = this.formTwoSubject.asObservable();
  private formThreeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formThree: Observable<boolean> = this.formThreeSubject.asObservable();

  editJobData: any;

  constructor(private empService: EmployerService, private auth: AuthService, private _snackBar: MatSnackBar, private employerService: EmployerService) { }

  next(formName, el: HTMLElement, current) {
    let currentName = 'form' + current;
    if (currentName == 'form1') {
      this.flagRole = true;
      this.postJobData.job_roles = [];
      for(let x in this.selectedJobRoles){
        let obj = {
          job_role: this.selectedJobRoles[x],
          experience: '',
        }
        this.postJobData.job_roles.push(obj);
        console.log("data", this.postJobData.job_roles)
      }
      if (this.postJobData.job_title && this.postJobData.company && this.postJobData.job_location && this.postJobData.employement_type && this.postJobData.job_type.name && this.postJobData.job_roles.length) {
        this.card2 = true;
        this.scroll(formName, el, current);
        //console.log("Inside..",this.postJobData)
      }
      else {
        // this._snackBar.open('please fill all required fields', 'Okay', {
        //   duration: 5000,
        // });
      }
    } else if (currentName == 'form2') {
      this.flagDesc = true;
      if (this.postJobData.job_description && this.postJobData.skills.primarySkills.length > 0 && this.postJobData.open_positions) {
        this.card3 = true;
        this.scroll(formName, el, current);
        console.log(this.postJobData)

      } else {
        // this._snackBar.open('job details required all fields', 'Okay', {
        //   duration: 5000,
        // });
      }
    }
    else {
      this.scroll(formName, el, current);
      console.log(this.postJobData)
    }
  }

  scroll(formName, el: HTMLElement, current) {
    let name: any = 'form' + formName + 'Subject';
    let currentName = 'form' + current;
    this.card[currentName] = false;
    this[name].next(false);
    setTimeout(
      () => {
        el.scrollIntoView({ behavior: 'smooth' });
      },
      100);
  }

  edit(formNumber, index?) {
    let name = 'form' + formNumber;
    this.card[name] = true;
    if(formNumber == 1 && this.editJobData && this.isEdit){
      this.getJobRoles(this.editJobData.job_type.name)
    }
    console.log(this.postJobData)
  }

  onChange(event) {
    this.postJobData.job_title = String(this.postJobData.job_title).trim().replace(/\s\s+/g, ' ');
    this.postJobData.company = String(this.postJobData.company).trim().replace(/\s\s+/g, ' ');
    this.postJobData.job_location = String(this.postJobData.job_location).trim().replace(/\s\s+/g, ' ');
    this.skillInput = String(this.skillInput).trim().replace(/\s\s+/g, ' ');
    this.question = String(this.question).trim().replace(/\s\s+/g, ' ');
  }

  addPrimarySkill(value) {
    if (this.postJobData.skills.primarySkills.includes(value) || this.postJobData.skills.additionalSkills.includes(value) || value == '' || value == " ") {
      this.skillInput = '';
      this._snackBar.open('Please check your input for multiple skills', 'Okay', {
        duration: 5000,
      });
    }
    else {
      this.showAddSkill1 = false;
      this.postJobData.skills.primarySkills.push(value);
      let popIndex = this.primarySkills.indexOf(value);
      this.primarySkills.splice(popIndex, 1);
      this.skillInput = ''
    }
  }

  addNewPrimarySkill() {
    if (this.postJobData.skills.primarySkills.includes(this.skillInput) || this.postJobData.skills.additionalSkills.includes(this.skillInput) || this.skillInput == ' ' || this.skillInput == "") {
      this.skillInput = '';
      this._snackBar.open('Please check your input for multiple skills', 'Okay', {
        duration: 5000,
      });
    }
    else {
      this.postJobData.skills.primarySkills.push(this.skillInput);
      this.allSkills.push(this.skillInput)
      this.empService.updateSkills(this.skillInput).then(
        (a) => {
          console.log('updated skills');
        }
      )
      this.newSkillAdded = true;
      this.skillInput = '';
      this.showAddSkill1 = false;
    }
  }

  onPrimaryChange(event) {
    if (event.target.value == ' ') {
      this.skillInput = ''
    }
    else
      if (this.primarySkills.findIndex(element => element.toLowerCase().includes((event.target.value).toLowerCase()))) {
        this.showAddSkill1 = true;
      }
      else {
        this.showAddSkill1 = false;
      }
  }

  removePrimarySkill(value) {
    this.primarySkills.push(value);
    let popIndex = this.postJobData.skills.primarySkills.indexOf(value);
    this.postJobData.skills.primarySkills.splice(popIndex, 1);
  }

  addAdditionalSkill(value) {
    if (this.postJobData.skills.additionalSkills.includes(value) || this.postJobData.skills.primarySkills.includes(value) || value == '' || value == " ") {
      this.skillInput = '';
      this._snackBar.open('Please check your input for multiple skills', 'Okay', {
        duration: 5000,
      });
    }
    else {
      this.showAddSkill2 = false;
      this.postJobData.skills.additionalSkills.push(value);
      let popIndex = this.additionalSkills.indexOf(value);
      this.additionalSkills.splice(popIndex, 1);
      this.additionalSkillInput = ''
    }
  }

  addNewAdditionalSkill() {
    if (this.postJobData.skills.primarySkills.includes(this.additionalSkillInput) || this.postJobData.skills.additionalSkills.includes(this.additionalSkillInput) || this.additionalSkillInput == ' ' || this.additionalSkillInput == "") {
      this.additionalSkillInput = '';
      this._snackBar.open('Please check your input for multiple skills', 'Okay', {
        duration: 5000,
      });
    }
    else {
      this.postJobData.skills.additionalSkills.push(this.additionalSkillInput);
      this.allSkills.push(this.additionalSkillInput)
      this.empService.updateSkills(this.additionalSkillInput).then(
        (a) => {
          console.log('updated skills');
        }
      )
      this.newSkillAdded = true;
      this.additionalSkillInput = '';
      this.showAddSkill2 = false;
    }
  }

  onAdditionalChange(event) {
    if (event.target.value == ' ') {
      this.additionalSkillInput = ''
    }
    else
      if (this.additionalSkills.findIndex(element => element.toLowerCase().includes((event.target.value).toLowerCase()))) {
        //console.log("INSIDE...")
        this.showAddSkill2 = true;
      }
      else {
        this.showAddSkill2 = false;
      }
  }

  removeAdditionalSkill(value) {
    this.additionalSkills.push(value);
    let popIndex = this.postJobData.skills.additionalSkills.indexOf(value);
    this.postJobData.skills.additionalSkills.splice(popIndex, 1);
  }




  ngOnInit() {

    console.log(this.empService.editJobData);
    if (this.empService.editJobData) {
      this.isEdit = true;
      this.card.form1 = false;
      this.card.form2 = false;
      this.card2 = this.card3 = true;
      this.formTwoSubject.next(false);
      this.formThreeSubject.next(false);
      this.postEnable = false;
      this.editEnable = true;
      this.editJobData = this.empService.editJobData;
      this.jobId = this.editJobData._id;
      this.postJobData.job_title = this.editJobData.job_title;
      this.postJobData.company = this.editJobData.company;
      this.postJobData.job_location = this.editJobData.job_location;
      this.postJobData.employement_type = this.editJobData.employement_type;
      this.postJobData.job_type = this.editJobData.job_type;
      this.postJobData.job_roles = this.editJobData.job_roles;
      this.postJobData.work_authorization = this.editJobData.work_authorization;
      this.postJobData.job_description = this.editJobData.job_description;
      this.postJobData.skills.primarySkills = this.editJobData.skills.primarySkills;
      this.postJobData.skills.additionalSkills = this.editJobData.skills.additionalSkills;
      this.postJobData.open_positions = this.editJobData.open_positions;
      this.questionList = this.editJobData.screening_questions;
      if (this.empService.editJobData.status == 'Posted') {
        console.log("status is posted")
        this.postJobData.status = this.editJobData.status;
      } else if (this.empService.editJobData.status == 'Draft') {
        this.EditDraftEnable = true;
        this.editEnable = false;
        console.log("status has to assign")
      }
    }

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    this.updateFAQs();
    this.auth.getUserId().subscribe(
      (user) => {
        this.postJobData.emp_id = user.uid;
      }
    );

    this.empService.getSkills().subscribe(
      (data: any) => {
        console.log(data)
        this.primarySkills = data.skills;
        this.allSkills = data.skills;
        this.filteredSkills = this.skillsControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterSkills(value))
          );
      }
    )
    this.updateLocations();
    this.getJobTypes();
  }

  updateLocations() {
    this.filteredLocations = this.locationControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterLocations(value))
    );
  }
  getLocations(event) {
    console.log(event.target.value);
    this.employerService.getLocations(event.target.value).subscribe(
      (a: any) => {
        let data = [];
        this.locationOptions = [];
        data = a.predictions;
        data.forEach(
          (q) => {
            this.locationOptions.push(q.terms[q.terms.length - 3].value + ', ' + q.terms[q.terms.length - 2].value);
            console.log(q.description)
          }
        )
        console.log(data);
        this.updateLocations();
      }
    )
  }

  updateFAQs() {
    this.filteredOptions1 = this.myControl1.valueChanges.pipe(
      startWith(''),
      map(value => this._filter1(value))
    );
  }

  searchFAQs(event) {
    if (event.target.value.trim() == ' ' || event.target.value.trim() == "") {
      this.showAddQns = true;
      this.question = ''
    } else {
      this.empService.getJobFAQs(event.target.value).subscribe((a) => {
        console.log(a);
        let arr = [];
        for (let x in a) {
          arr.push(a[x].question)
        }
        this.options1 = arr;
        this.updateFAQs();
      });
      this.showAddQns = false;
    }
  }

  addQues() {
    this.questionList.push(this.question);
    this.question = '';
    console.log(this.questionList);
    this.showAddQns = true;
  }

  postQuestions() {
    //  for(let x in this.questionList){
    //   this.empService.postJobFAQs({'question':this.questionList[x]}).subscribe((a)=>{
    //     console.log(a);
    //   })
    //  }

  }

  closeError() {
    this.statusFailure = false;
    document.getElementById("closeModalButton").click();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }
  private _filter1(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options1.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterSkills(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.primarySkills.filter(option => option.toLowerCase().includes(filterValue));
  }

  onSubmit(status) {
    //console.log("before: ",this.postJobData)
    if (this.postJobData.job_title && this.postJobData.company && this.postJobData.job_location
      && this.postJobData.employement_type && this.postJobData.job_type.name && this.postJobData.job_roles.length
      && this.postJobData.job_description && this.postJobData.skills.primarySkills.length > 0 && this.postJobData.open_positions) {
      this.statusLoading = true;
      this.postJobData['screening_questions'] = this.questionList;
      //this.postJobData.job_roles = this.postJobData.job_roles;   //this.jobRoleExperienceList.filter(value => value.experience != '');
      // this.postJobData.job_type = this.jobType;
      // this.postJobData.job_title = this.postJobData.job_title;
      // this.postJobData.open_positions = this.postJobData.open_positions;
      // this.postJobData.job_location = this.postJobData.job_location;
      // this.postJobData.company = this.postJobData.company;
       this.postJobData.status = status;
      //console.log("after: ",this.postJobData)
      this.empService.postJob(this.postJobData).subscribe(async (a) => {
        await console.log("Success", a);
        if (status == 'Posted') {
          this.sucessMsg = "Job Posted Sucessfully"
        } else if (status == 'Draft') {
          this.sucessMsg = "Saved as Draft Sucessfully"
        }
        this.statusSuccess = true;
        this.statusFailure = false;
        this.statusLoading = false;
        console.log(this.statusSuccess)
      },
        (error) => {
          this.statusFailure = true;
          this.statusSuccess = false;
          this.statusLoading = false;
        })
    } else {
      // this._snackBar.open('Check', 'Okay', {
      //   duration: 5000,
      // });
    }

  }
  onEdit(status?) {
    if (this.postJobData.job_title && this.postJobData.company && this.postJobData.job_location && this.postJobData.employement_type && this.postJobData.job_description && this.postJobData.skills.primarySkills.length > 0) {
      this.statusLoading2 = true;
      this.postJobData['screening_questions'] = this.questionList;
      this.postJobData.job_title = this.postJobData.job_title;
      this.postJobData.job_location = this.postJobData.job_location;
      this.postJobData.company = this.postJobData.company;
      if (this.editJobData.status == 'Draft') {
        this.postJobData.status = status;
      }
      this.empService.updateJob({ ...this.postJobData, _id: this.jobId }).subscribe(
        (a) => {
          console.log(a);
          this.statusSuccess2 = true;
          this.statusFailure2 = false;
          this.statusLoading2 = false;
          this.empService.editJobData = '';
        },
        (error) => {
          this.statusFailure2 = true;
          this.statusSuccess2 = false;
          this.statusLoading2 = false;
        }
      )
    } else {
      // this._snackBar.open('please fill all the details', 'Okay', {
      //   duration: 5000,
      // });
    }

  }

  editFun(i) {

    if (this.question == "") {
      this.question = this.questionList[i];
      this.questionList.splice(i, 1);
    } else {
      console.log("not empty")
    }

  }

  private _filterLocations(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.locationOptions.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  getJobRoles(event) {
    console.log(event)
    console.log("Edit??", this.isEdit)
    if(!this.isEdit){
      this.postJobData.job_roles = [];
    }
    this.selectedJobRoles = [];
    this.jobType.name = event
    var checker: boolean = false;
    this.jobType.total_experience = ''
    this.empService.getJobRoles(event).subscribe(
      (a) => {
        console.log(a)
        console.log("Edit?",this.isEdit)
        this.jobRoleExperienceList = []
        if(this.isEdit){
          console.log("Edit:", this.editJobData.job_roles[0]['job_role'])
          for(let x in a){
            for(let y in this.editJobData.job_roles){
              if(a[x]['name'] == this.editJobData.job_roles[y]['job_role']){
                var obj = {
                  job_role: a[x]['name'],
                  experience: '',
                  selected: true
                }
                checker = true;
                console.log("checked", this.editJobData.job_roles[y]['job_role'])
                break;
              }
            }
            if(checker == false){
              var obj = {
                job_role: a[x]['name'],
                experience: '',
                selected: false
              }
            }
            else{
              checker = false;
            }
            this.jobRoleExperienceList.push(obj)
          }
        }
        else{
          console.log("Else: ", this.isEdit)
          for (let x in a) {
            var obj = {
              job_role: a[x]['name'],
              experience: '',
              selected: false
            }
            this.jobRoleExperienceList.push(obj)
          }
        }
        this.isEdit = false;
        console.log(this.isEdit);
      }
    )
  }

  getJobTypes() {
    this.empService.getJobTypes().subscribe(
      (a: any) => {
        console.log(a)
        this.jobTypes = a;
      }
    )
  }

  setTotalExperience(event) {
    this.jobType.total_experience = event.value
  }

  dummySubmit() {
    console.log()
  }

  test() {
    //console.log($event.target)
    this.flagRole = true;
    for(let x in this.jobRoleExperienceList){ 
      if(this.jobRoleExperienceList[x].selected && !this.selectedJobRoles.includes(this.jobRoleExperienceList[x].job_role)){ 
        this.selectedJobRoles.push(this.jobRoleExperienceList[x].job_role); 
        console.log("new",this.selectedJobRoles)
      }
      if(!this.jobRoleExperienceList[x].selected && this.selectedJobRoles.includes(this.jobRoleExperienceList[x].job_role)){ 
        var i = this.selectedJobRoles.indexOf(this.jobRoleExperienceList[x].job_role); 
        this.selectedJobRoles.splice(i, 1); 
        console.log("delete",this.selectedJobRoles); 
      } 
    }
  }
}
